module.exports = __webpack_public_path__ + "assets/img/6b7556f3e30c7efc1f962bd56176eb41.png";